const options = {
  5: "bg-purple-500/5",
  10: "bg-purple-500/10",
  25: "bg-purple-500/25",
  50: "bg-purple-500/50",
  75: "bg-purple-500/75",
  90: "bg-purple-500/90",
  100: "bg-purple-500",
};

const from = {
  5: "from-purple-500/5",
  10: "from-purple-500/10",
  25: "from-purple-500/25",
  50: "from-purple-500/50",
  75: "from-purple-500/75",
  90: "from-purple-500/90",
  100: "from-purple-500",
};

export default function getBackgroundPurple500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
